import { Link, useNavigate } from "react-router-dom";
import ShowOnLogin, { ShowOnLogout } from "../hiddenLink/hiddenLink";
import { AdminOnlyLink } from "../hiddenLink/AdminOnlyRoute";
import { useDispatch } from "react-redux";
import { logout, RESET_AUTH } from "../../redux/features/auth/authSlice";

const DropDownFive = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutUser = async () => {
    await dispatch(logout());
    await dispatch(RESET_AUTH());
    navigate("/login");
  };
  return (
    <div className="dropDownMenu5">
      <span>
        <Link to="/">Home</Link>
      </span>
      <span>
        <Link to="/profile">Profile</Link>
      </span>
      <span>
        <Link to="/about">About</Link>
      </span>
      <ShowOnLogout>
        <span>
          <Link to="/login">Login</Link>
        </span>
      </ShowOnLogout>
      <ShowOnLogout>
        <span>
          <Link to="/register">Register</Link>
        </span>
      </ShowOnLogout>
      <ShowOnLogin>
        <span>
          <Link to="/" onClick={logoutUser}>
            Logout
          </Link>
        </span>
      </ShowOnLogin>
      <AdminOnlyLink>
        <span>
          <Link to="/admin/home">Admin</Link>
        </span>
      </AdminOnlyLink>
    </div>
  );
};
export default DropDownFive;
